import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EWeekdays } from "../../../../enums/event.enums";

export interface WeekdaySelectorProps {
  value: EWeekdays[];
  onChange: (next: EWeekdays[]) => void;
}

export const WeekdaySelector = ({ value, onChange }: WeekdaySelectorProps) => {
  const days: { label: string; key: EWeekdays }[] = [
    { label: "S", key: EWeekdays.SUNDAY },
    { label: "M", key: EWeekdays.MONDAY },
    { label: "T", key: EWeekdays.TUESDAY },
    { label: "W", key: EWeekdays.WEDNESDAY },
    { label: "T", key: EWeekdays.THURSDAY },
    { label: "F", key: EWeekdays.FRIDAY },
    { label: "S", key: EWeekdays.SATURDAY },
  ];

  const handleToggle = (day: EWeekdays) => {
    const exists = value.includes(day);
    const next = exists ? value.filter((d) => d !== day) : [...value, day];
    onChange(next);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 1.5,
        gap: 2,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: "var(--fx-surface-texttertiary, #94A3B8)",
          fontWeight: 600,
          fontSize: 14,
          textAlign: "center",
        }}
      >
        Repeat on
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 1.5,
          justifyContent: "center",
        }}
      >
        {days.map((d, idx) => {
          const active = value.includes(d.key);
          return (
            <Tooltip title={d.key} key={idx}>
              <IconButton
                size="medium"
                onClick={() => handleToggle(d.key)}
                sx={{
                  width: 46,
                  height: 46,
                  borderRadius: "50%",
                  background: active ? "#0071e3" : "var(--fx-surface-sunken, #F8FAFC)",
                  color: active ? "#fff" : "var(--fx-surface-text, #0F172A)",
                  fontSize: 15,
                  fontWeight: 600,
                  transition: "all 0.2s",
                  "&:hover": {
                    background: active ? "#0077ed" : "var(--fx-surface-muted, #F1F5F9)",
                    transform: "scale(1.08)",
                  },
                }}
              >
                {d.label}
              </IconButton>
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
};
